const _ = require('underscore');
const moreThanZero = function (value) {
    if (value > 0) {
        return true;
    }
    return false;
};
const notEmpty = function (value) {
    return !_.isEmpty(value);
};
const checkODPairs = function (ODPairs) {
    let result = !_.isEmpty(ODPairs);
    if (ODPairs) {
        for (const odPair of ODPairs) {
            result = result && !_.isEmpty(odPair.origin_city);
            result = result && !_.isEmpty(odPair.destination_city);
            result = result && !_.isEmpty(odPair.values);
        }
    }
    return result;
};
module.exports = [
    {
        value: 'weightDistance',
        name: 'Weight/Distance',
        validators: [
            {
                name: 'distance_ranges',
                check: notEmpty,
            },
            {
                name: 'weight_ranges',
                check: notEmpty,
            },
            {
                name: 'prices',
                check: notEmpty,
            },
        ],
    },
    {
        value: 'originDestination',
        name: 'Origin/Destination',
        validators: [
            {
                name: 'od_pairs',
                check: checkODPairs,
            },
        ],
    },
    {
        value: 'day',
        name: 'Day',
        validators: [
            {
                name: 'rate_per_day',
                check: moreThanZero,
            },
        ],
    },
    {
        value: 'palletBase',
        name: 'Pallet Base',
        validators: [
            {
                name: 'load_ranges',
                check: notEmpty,
            },
            {
                name: 'distance_ranges',
                check: notEmpty,
            },
            {
                name: 'weight_ranges',
                check: notEmpty,
            },
            {
                name: 'prices',
                check: notEmpty,
            },
        ],
    },
];
